import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  err: Error | null;
}

/** Catches render errors in children so a failed subtree does not leave a blank WebView. */
export class MiniappErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    console.error('[MiniappErrorBoundary]', err, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.err) {
      return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center bg-surface-secondary px-6 py-12 text-center">
          <p className="mb-2 font-medium text-text-danger">Something went wrong</p>
          <pre className="mb-6 max-w-full whitespace-pre-wrap break-all text-left text-xs text-text-secondary">
            {this.state.err.message}
          </pre>
          <button
            type="button"
            className="rounded-lg bg-text-brand px-4 py-2 text-sm text-white"
            onClick={() => this.setState({ err: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
